// src/pages/EldAudit.js
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EldAudit = () => {
  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const loggedInId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const userId = isAdmin && paramId ? paramId : loggedInId;

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [file, setFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const fetchAudits = useCallback(async () => {
    if (!userId) return;
    try {
      const res = await axios.get(`${API_BASE}/api/elduaudit/${userId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (Array.isArray(res.data)) setUploadedFiles(res.data);
    } catch (err) {
      console.error("Fetch failed", err);
    }
  }, [API_BASE, userId]);

  useEffect(() => {
    fetchAudits();
  }, [fetchAudits]);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

    if (allowedTypes.includes(selected.type)) {
      setFile(selected);
    } else {
      alert("Only PDF, JPG, or PNG files are allowed!");
      setFile(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !userId) {
      alert("Please select a PDF file and ensure you are logged in.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", userId);

    try {
      const res = await axios.post(
        `${API_BASE}/api/elduaudit/upload?userId=${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const { filename, originalName } = res.data || {};
      if (typeof filename === "string") {
        setUploadedFiles((prev) => [
          ...prev,
          {
            ea_form: filename,
            ea_form_original: originalName || filename,
            ea_submitted_date: new Date(),
          },
        ]);
        setFile(null);
        alert("✔️ ELD Audit uploaded!");
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed.");
    }
  };

  const handleCancel = () => {
    if (isAdmin && paramId) {
      navigate(`/userhome/${paramId}`);
    } else {
      navigate("/userhome");
    }
  };

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center pt-3">
        <div style={{ fontSize: "18px", fontWeight: "500" }}>ELD Audit</div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Return
        </button>
      </div>

      <div className="form-wrapper my-4">
        <div className="row align-items-center mb-4">
          <div className="col-4"></div>
          <div className="col-4 text-center">
            <h3 className="mb-0">ELD Audit</h3>
          </div>
          <div className="col-4 text-end">
            <div>New-Way Trucking Ltd</div>
            <div>7725 48 St. SE, Calgary</div>
            <div>Alberta, Canada T2C 2V3</div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Select File (PDF / JPG / PNG) *</label>
            <input
              type="file"
              className="form-control"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={handleFileChange}
              required
            />
          </div>
          <div className="d-flex justify-content-end">
            <button type="submit" className="btn btn-primary" disabled={!file}>
              Upload
            </button>
          </div>
        </form>

        {uploadedFiles.length > 0 && (
          <div className="mt-4 p-3 bg-light border rounded">
            <div className="text-muted mb-2">Uploaded Versions</div>
            <ul className="list-unstyled mb-0">
              {uploadedFiles.map((f, idx) => (
                <li key={idx}>
                  <a
                    href={`${API_BASE}/uploads/elduaudit/${f.ea_form}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={f.ea_form_original || f.ea_form}
                  >
                    {f.ea_form_original || f.ea_form}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default EldAudit;
